import styled from "styled-components";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

/* ---------- CAMPOS GENERALES ---------- */
export const FieldsColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

/* ---------- DATE PICKER ---------- */
export const DatePickerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1rem;

  .orBlock {
    display: flex;
    align-items: end;
    margin-bottom: 4px;
  }
`;

export const DatePickerLabel = styled.label`
  font-size: 0.95rem;
  font-weight: 500;
  margin-bottom: 0.3rem;
  display: block;
`;

export const StyledDateTimePicker = styled(DateTimePicker)`
  & .MuiInputBase-root {
    border-radius: 8px;
    border-color: #fe2f67;
    &:hover {
      border-color: #fe2f67;
    }
    &.Mui-focused {
      border-color: #fe2f67;
    }
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: #fe2f67;
  }
  & .MuiSvgIcon-root {
    color: #fe2f67;
  }
`;

export const InputDatePickerField = styled.input<{ $status?: string }>`
  padding: 15px 20px;
  font-size: 0.9rem;
  border: 1px solid #8692a6;
  border-radius: 5px;
  outline: none;

  &:focus {
    border: 1px solid #fe2f67!important;
    outline: none;
  }
`;

export const DatesRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const DateCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DateSeparator = styled.span`
  font-size: 1.5em;
  color: #555;
`;

export const Label = styled.label`
  display: block;
  margin-top: 12px;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const Required = styled.span`
  color: #e53935;
`;

/* ---------- OTROS ---------- */
export const OrContainer = styled.div`
  font-size: 0.9rem;
  white-space: nowrap;
`;

export const OngoingContainer = styled.button`
  background: transparent;
  border: 1px solid #8f8f8f;
  border-radius: 5px;
  font-size: 0.9rem;
  cursor: pointer;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;

  &:disabled {
    cursor: not-allowed;
    background-color: #f2f2f2;
    color: #999999;
    border-color: #d3d3d3;
  }

  &:hover:not(:disabled) {
    background-color: #f5f5f5;
  }
`;

export const LocationContainer = styled.p`
  font-size: 0.9rem;
  margin-bottom: 1rem;
`;
